import { cancelIdleCallback, requestIdleCallback } from '~/components/Util/idleCallbackUtil';
import { MapCache, memoize } from 'lodash';

const DEFAULT_MAX_SIZE = 500;

export const memoizeCappedWith = <T extends (...args: any) => any>(
  func: T,
  resolver?: (...args: Parameters<T>) => string,
  option: { max?: number } = {}
) => {
  let cache: MapCache;
  let requestId;
  const result = memoize(func, function (...key) {
    if (cache.size >= (option.max ?? DEFAULT_MAX_SIZE)) {
      cancelIdleCallback(requestId);
      requestId = requestIdleCallback(
        () => {
          cache.clear();
        },
        { timeout: 2000 }
      );
    }
    return resolver ? resolver(...key) : key[0];
  });

  cache = result.cache;
  return result;
};
